/** TTL cache React Query per metadata sessioni e gruppi (tabella /sessions/group). */
export const SESSION_GROUP_QUERY_STALE_TIME = 5 * 60 * 1000;
export const SESSION_GROUP_QUERY_GC_TIME = 5 * 60 * 1000;
